import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";
import { useStaffLayout } from "../../../Components/Context/CandidateLayoutContext";

function SalaryPayList({ isAdmin }) {
  const navigate = useNavigate();

  const { privilegeData } = useStaffLayout();

  function hassalpayAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("salary pay");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hassalpayEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("salary pay");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }
  
  const columns = [
    { field: "SPFL_Id", label: "#" },
    { field: "SPFL_Name", label: "Salary Pay Type" },
    { field: "SPFL_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();

  const actions = [
    hassalpayEditprivilege(privilegeData) && {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.SPFL_Id));

        navigate(
          `/SalaryPayLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ].filter(Boolean);

  return (
    <DynamicTable
      columns={columns}
      actions={actions}
      dataAPI={`/SalaryPayFrequency/list`}
      title={`Salary Pay`}
      {...(hassalpayAddprivilege(privilegeData) && {
        linkvalue: `/SalaryPayLookup/Add?${searchParams.toString()}`,
      })}
    />
  );
}

export default SalaryPayList;
